import React from 'react';
import PropTypes from 'prop-types';
const find = require('lodash/find');
const orderBy = require('lodash/orderBy');
const filter = require('lodash/filter');
const values = require('lodash/values');

const KeyboardUtil = require("../../../util/keyboard");
import { ExpandableRadioItem } from './TreeItems.js';

const propTypes = {
    id: PropTypes.string.isRequired,
    className: PropTypes.string,
    selectedChannelId: PropTypes.number,
    selectedFolderId: PropTypes.string,
    channels: PropTypes.array.isRequired,
    folders: PropTypes.object.isRequired,
    foldersFlat: PropTypes.object.isRequired,
    onSelectChannel: PropTypes.func,
    onSelectFolder: PropTypes.func,
    excludeFolderId: PropTypes.string,
};

const defaultProps = {
    className: '',
    selectedChannelId: null,
    onSelectChannel: null,
    onSelectFolder: null,
    excludeFolderId: null,
};

class ChannelFolderTree extends React.Component {
    constructor(props) {
        super(props);
        this._createExpandedObjs = this._createExpandedObjs.bind(this);
        const expandedObj = this._createExpandedObjs({}, {}, props.selectedChannelId, props.selectedFolderId, true);
        this.state = {
            expandedChannels: expandedObj.expandedChannelsObj,
            expandedFolders: expandedObj.expandedFoldersObj,
        }
        this._toggleExpanable = this._toggleExpanable.bind(this);
        this._setExpandedExpandable = this._setExpandedExpandable.bind(this);
        this._makeSelection = this._makeSelection.bind(this);
        this.onSelectableClick = this.onSelectableClick.bind(this);
        this.onSelectableKeyDown = this.onSelectableKeyDown.bind(this);
        this.onExpandableClick = this.onExpandableClick.bind(this);
        this.onExpandableKeyDown = this.onExpandableKeyDown.bind(this);
        this.stopPropagation = this.stopPropagation.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (
            nextProps.selectedFolderId === this.props.selectedFolderId
            && nextProps.selectedChannelId === this.props.selectedChannelId
        ) {
            return;
        }
        const expandedObj = this._createExpandedObjs(this.state.expandedChannels, this.state.expandedFolders, nextProps.selectedChannelId, nextProps.selectedFolderId);
        this.setState({ expandedChannels: expandedObj.expandedChannelsObj, expandedFolders: expandedObj.expandedFoldersObj });
    }

    // expandToSelected ensures that the expandable containing the selected selectable shows as expanded. currently only used in constructor.
    _createExpandedObjs(baseChannelObj, baseFolderObj, selectedChannelId, selectedFolderId, expandToSelected) {
        let expandedChannelsObj = { ...baseChannelObj };
        let expandedFoldersObj = { ...baseFolderObj };
        if (expandToSelected && !!selectedFolderId) {
            let selectedFolder;
            Object.keys(this.props.foldersFlat).forEach((channelId) => {
                selectedFolder = find(this.props.foldersFlat[channelId], { id: selectedFolderId });
            })

            if (!!selectedFolder) {
                expandedChannelsObj[selectedFolder.user_id] = true;
                if (!!selectedFolder.parent_id) expandedFoldersObj[selectedFolder.parent_id] = true;
                if (!!selectedFolder.gp_id) expandedFoldersObj[selectedFolder.gp_id] = true;
            }
            else {
                console.warn(`ChannelFolderTree._createExpandedObjs() - Unable to find selectedFolderId "${selectedFolderId}" in foldersFlat`);
            }
        }      

        return { expandedChannelsObj: expandedChannelsObj, expandedFoldersObj: expandedFoldersObj };
    }

    _toggleExpanable(type, id) {
        if (type === 'channel') {
            this.setState({
                expandedChannels: { ...this.state.expandedChannels, [id]: !this.state.expandedChannels[id] }
            });
        }
        else if (type === 'folder') {
            this.setState({
                expandedFolders: { ...this.state.expandedFolders, [id]: !this.state.expandedFolders[id] }
            });
        }
    }

    _setExpandedExpandable(type, id, state) {
        if (type === 'channel') {
            if (this.state.expandedChannels[id] === state) {
                return;
            }

            this.setState({
                expandedChannels: { ...this.state.expandedChannels, [id]: state }
            });
        }
        else if (type === 'folder') {
            if (this.state.expandedFolders[id] === state) {
                return;
            }

            this.setState({
                expandedFolders:  { ...this.state.expandedFolders, [id]: state }
            });
        }
    }

    _makeSelection(type, id) {
        if (type === 'channel' && !!this.props.onSelectChannel) {
            this.props.onSelectChannel(id);
        }
        else if (type === 'folder' && !!this.props.onSelectFolder) {
            this.props.onSelectFolder(id);
        }
        else {
            console.error(`ChannelFolderTree - _makeSelection() unrecognized type: ${type} or missing selector function`);
        }
    }

    onSelectableClick(type, id, e) {
        e.stopPropagation();
        this._makeSelection(type, id);
    }

    onSelectableKeyDown(type, id, e) {
        e.stopPropagation();

        if (KeyboardUtil.isSelectKey(e.keyCode)) {
            e.preventDefault(); //stop spacebar from scrolling
            this._makeSelection(type, id);
        }
    }

    onExpandableClick(type, id, e) {
        this._toggleExpanable(type, id);
    }

    onExpandableKeyDown(type, id, e) {
        if (KeyboardUtil.isSelectKey(e.keyCode)) {
            e.preventDefault(); //stop spacebar from scrolling
            this._toggleExpanable(type, id);
        }
        else if (KeyboardUtil.isRightArrow(e.keyCode)) {
            this._setExpandedExpandable(type, id, true);
        }
        else if (KeyboardUtil.isLeftArrow(e.keyCode)) {
            this._setExpandedExpandable(type, id, false);
        }
    }

    stopPropagation(e) {
        e.stopPropagation();
    }

    render() {
        const _channels = orderBy(this.props.channels, [channel => channel.name.toLowerCase()], ['asc']);
        return (
            <ul
                id={this.props.id}
                className={this.props.className ? "exp-tree " + this.props.className : "exp-tree"}
                role="radiogroup"
            >
                {_channels.map((channel) => {
                    const sortedChannelFolders = orderBy(this.props.folders[channel.id] || [], [folder => folder.name.toLowerCase()], ['asc']);
                    let depth = 1;

                    return (
                        <li key={channel.id} className="exp-li">
                            <ExpandableRadioItem
                                expandDisabled={sortedChannelFolders.length === 0}
                                expanded={this.state.expandedChannels[channel.id] || false}
                                onExpandClick={this.onExpandableClick.bind(this, 'channel', channel.id)}
                                onExpandKeyDown={this.onExpandableKeyDown.bind(this, 'channel', channel.id)}
                                label={channel.name}
                                labelId={`exp-ch-${channel.id}`}
                                checked={this.props.selectedChannelId === channel.id}
                                onRadioClick={this.onSelectableClick.bind(this, 'channel', channel.id)}
                                onRadioKeyDown={this.onSelectableKeyDown.bind(this, 'channel', channel.id)}
                            />

                            {/* onClick & onKeyDown stopPropagation handlers prevent clicks getting through 'ui holes' from bubbling up to expandable handler */}
                            <ul
                                className={`exp-selectable-list exp-l${depth}`}
                                onClick={this.stopPropagation}
                                onKeyDown={this.stopPropagation}
                                style={this.state.expandedChannels[channel.id] ? {}: { display: "none" }}
                            >
                                {sortedChannelFolders.map((channelFolder) => 
                                    <FolderSubfolderList
                                        key={channelFolder.id}
                                        folder={channelFolder}
                                        selectedFolderId={this.props.selectedFolderId}
                                        expandedFolders={this.state.expandedFolders}
                                        onExpandableClick={this.onExpandableClick}
                                        onExpandableKeyDown={this.onExpandableKeyDown}
                                        onSelectableClick={this.onSelectableClick}
                                        onSelectableKeyDown={this.onSelectableKeyDown}
                                        excludeFolderId={this.props.excludeFolderId}
                                        depth={depth}
                                    />
                                )}
                            </ul>
                        </li>
                    )
                })}
            </ul>
        );
    }
}

ChannelFolderTree.propTypes = propTypes;
ChannelFolderTree.defaultProps = defaultProps;

export default ChannelFolderTree;

function FolderSubfolderList(props) {
    if (props.excludeFolderId === props.folder.id) return null; // ensure that tree is not rendered at or below exclusion
    function stopPropagation(e) { e.stopPropagation }
    const childFolders = orderBy(values(props.folder.children || {}), [folder => folder.name.toLowerCase()], ['asc']);

    return (
        <li key={props.folder.id} className="exp-li">
            <ExpandableRadioItem
                expanded={props.expandedFolders[props.folder.id] || false}
                expandDisabled={childFolders.length === 0}
                onExpandClick={props.onExpandableClick.bind(null, 'folder', props.folder.id)}
                onExpandKeyDown={props.onExpandableKeyDown.bind(null, 'folder', props.folder.id)}
                label={props.folder.name}
                labelId={`exp-fo-${props.folder.id}`}
                labelIconClass="fa fa-folder"
                checked={props.selectedFolderId === props.folder.id}
                onRadioClick={props.onSelectableClick.bind(null, 'folder', props.folder.id)}
                onRadioKeyDown={props.onSelectableKeyDown.bind(null, 'folder', props.folder.id)}
            />

            {/* onClick & onKeyDown stopPropagation handlers prevent clicks getting through 'ui holes' from bubbling up to expandable handler */}
            <ul
                className={`exp-selectable-list exp-l${props.depth}`}
                onClick={stopPropagation}
                onKeyDown={stopPropagation}
                style={props.expandedFolders[props.folder.id] ? {}: { display: "none" }}
            >
                {childFolders.map((childFolder) => 
                    <FolderSubfolderList key={childFolder.id} {...props} folder={childFolder} depth={props.depth+1} />
                )}
            </ul>
        </li>
    );
}

FolderSubfolderList.propTypes = {
    folder: PropTypes.object.isRequired,
    selectedFolderId: PropTypes.string,
    expandedFolders: PropTypes.object.isRequired,
    onExpandableClick: PropTypes.func.isRequired,
    onExpandableKeyDown: PropTypes.func.isRequired,
    onSelectableClick: PropTypes.func.isRequired,
    onSelectableKeyDown: PropTypes.func.isRequired,
    depth: PropTypes.number.isRequired,
    excludeFolderId: PropTypes.string,
};

FolderSubfolderList.defaultProps = {
    selectedFolderId: null,
    excludeFolderId: null,
}